import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpfleet1putPutFleetUnitResponseSchema = jsonObject
export type tcpfleet1putPutFleetUnitResponse = z.infer<typeof tcpfleet1putPutFleetUnitResponseSchema>
